import {Component} from '@angular/core';

import {RouterOutlet} from '@angular/router';
import {MatGridListModule} from "@angular/material/grid-list";
import {MatSidenavModule} from "@angular/material/sidenav";
import {ReactiveFormsModule} from "@angular/forms";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatInputModule} from "@angular/material/input";
import {LanguageSwitcherComponent} from "../../../shared/i18n/language-switcher.component";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, MatGridListModule, MatSidenavModule, MatAutocompleteModule, MatInputModule, ReactiveFormsModule, LanguageSwitcherComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title: string = 'journal-frontend';

    constructor() {
    }
}
